import {Expose, Type} from 'class-transformer';

import {GroupType} from './groups/group';
import {ApiResponse} from './apiResponse';

/**
 * Each group, if it is not created from user data and content. Must be created for some case<br>
 * For example to discuss inventory with id 1 with all of their old owners, then case will be<br>
 * ```json
 * [{
 *  entity: inventory,
 *  id: 1
 * }]
 * ```
 * <br>
 * Or to worker with id, want to discuss inventory with id 1 with only responsible, then case will be<br>
 * ```json
 * [
 *  {
 *   entity: inventory,
 *   id: 1
 *  },
 *  {
 *   entity: worker,
 *   id: 1
 *  }
 * ]
 * ```<br>
 * Or two worker with id, 1 and 2, want tot talk, then case will be<br>
 * ```json
 * [
 *  {
 *   entity: worker,
 *   id: 1
 *  },
 *  {
 *   entity: worker,
 *   id: 2
 *  }
 * ]
 * ```<br>
 * <br>
 * Case work as composite key, so ti means that cant be two group with same case id
 *
 * @category Common entities
 * */
export class CaseMetadata {
  /**
   * Case items
   * */
  @Type(() => CaseMetadataItem)
  items: CaseMetadataItem[] = [];

  // @todo add serialization
  /**
   * @ignore
   * */
  @Expose({name: 'serializedString'})
  private _serializedString?: string = null;

  /**
   * Get Serialized string, using to compare groups
   * */
  get serializedString(): string {
    return this._serializedString ? this._serializedString : this.serializeCaseItems();
  }

  /**
   * @ignore
   * */
  set serializedString(value: string) {
    this._serializedString = value;
  }

  /**
   * @return if group with this case `public` or `private`
   * */
  getGroupType?(): GroupType {
    return this.items.length === 2 && this.items[0].entity === 'worker' && this.items[1].entity === 'worker' ? 'private' : 'public';
  }

  constructor(items: (CaseMetadataItem | Partial<CaseMetadataItem>)[] = []) {
    this.items = items.map(item => new CaseMetadataItem(item));

    this.serializeCaseItems();
  }


  /**
   * @ignore
   * */
  private serializeCaseItems() {
    const c = this.items.sort((a, b) => a.service.localeCompare(b.service)
      || a.entity.localeCompare(b.entity)
      || a.id?.toString()?.localeCompare(b.id?.toString()));

    this._serializedString = c.map((item) => `${item.service?.toLowerCase()},${item.entity?.toLowerCase()},${item.id?.toString()?.toLowerCase()}`).join(';');

    return this._serializedString;
  }
}

/**
 * Case metadata item
 *
 * @category Common entities
 * */
export class CaseMetadataItem {
  service: string;
  entity: string;
  id: string | number;

  constructor(item: Partial<CaseMetadataItem> = null) {
    Object.assign(this, item);
  }
}
